import { useQuery } from "@tanstack/react-query";
import config from "configs/config";
import apiClient from "lib/api-client";

export const fetchDesignData = async (designNumber) => {
  const response = await apiClient.get(`${config.baseUrl}/api/v1/styles/getExactDesign/${designNumber}`);
  return response?.data?.data;
};

export const useGetExcatDesign = (designNumber) => {
  return useQuery({
    queryKey: ["designData", designNumber],
    queryFn: () => fetchDesignData(designNumber),
    enabled: !!designNumber,
    staleTime: 3000,
  });
};
